import { makeDoneLeadsPending } from "api/Pendings"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"


export const useMakeDontLeadPending = () => {
    const queryClinet = useQueryClient();
    return useMutation(makeDoneLeadsPending, {
        onSuccess: () => {
            queryClinet.invalidateQueries('leadPending');
            queryClinet.invalidateQueries(['widgetData','Leads Pendings List'])

            toast.success('Pending is done')
        },
        onError: () => {
            toast.error('Something went wrong!')
        }
    })
}